export default "__VITE_ASSET__soilFIux__"